const state = {
  error_logs: null,
};

export default state;
